/* screens/settings/businessSubtabs.js — состав подвкладок «Для бизнеса» (чистая логика).

   «Интеграции» помечена section:'integrations' — тариф пространства (workspace.sections.
   integrations === false) убирает её целиком, вместе с подсказкой «нет в тарифе»:
   у команды, которой договор интеграций не даёт, этой вкладки в интерфейсе быть не должно.
   Пространство — то, что ВЫБРАНО в разделе (может не совпадать с активным). */

import { isSectionEnabled } from '../../lib/planSections.js';

export const DEFAULT_BUSINESS_SUBTAB = 'tariff';

export const BUSINESS_SUBTABS = [
  { value: 'tariff', label: 'Тариф' },
  { value: 'restaurant', label: 'Заведение' },
  { value: 'knowledge', label: 'База знаний' },
  { value: 'team', label: 'Команда' },
  { value: 'integrations', label: 'Интеграции', section: 'integrations' },
];

/** Подвкладки, доступные пространству (закрытые тарифом не отдаём). */
export function visibleBusinessSubtabs(workspace) {
  return BUSINESS_SUBTABS.filter((t) => !t.section || isSectionEnabled(workspace, t.section));
}

/**
 * Какую подвкладку показывать: запрошенную, если она доступна, иначе — по умолчанию.
 * Закрывает deep-link'и (?sub=integrations, &biz=integrations) для закрытого раздела:
 * ни пустой панели, ни падения.
 */
export function resolveBusinessSubtab(requested, workspace) {
  const found = visibleBusinessSubtabs(workspace).find((t) => t.value === requested);
  return found ? found.value : DEFAULT_BUSINESS_SUBTAB;
}
